import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Paths from "routes/Paths";

import styles from "./PublicTreeNotice.module.css";

/**
 * Shown wherever a tree is about to become public (TTAPI-47, GDPR finding F-08). Family trees name
 * living people who never signed up; a public tree shows them to anyone, search engines included. This
 * asks the author to leave out private details about living people and tells them how someone named
 * in a tree can have it changed — the same route the privacy policy promises.
 */
export const PublicTreeNotice = () => {
	const { t } = useTranslation("common");

	return (
		<p className={styles.notice} role="note">
			<strong className={styles.title}>{t("publicTreeNotice.title")}</strong> {t("publicTreeNotice.body")}{" "}
			{/* New tab: the notice sits inside tree forms, and navigating away would discard what was typed. */}
			<Link className={styles.link} rel="noopener noreferrer" target="_blank" to={Paths.rightsPolicy}>
				{t("publicTreeNotice.link")}
			</Link>
		</p>
	);
};

export default PublicTreeNotice;
